import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Space } from '@arco-design/web-react';
import { IconDelete, IconEdit } from '@arco-design/web-react/icon';

import styles from './existing-model-storage-card.module.less';
import type { MaasModelSourceEntry } from './modelInstanceTypes';

interface ExistingModelStorageCardProps {
  modelLines: ReactNode;
  storageLines: ReactNode;
  onEdit?: () => void;
  onDelete?: () => void;
  readOnly?: boolean;
}

/** 已有模型场景：模型 | 存储 | 操作 三列合一卡片 */
export function ExistingModelStorageCard({ modelLines, storageLines, onEdit, onDelete, readOnly }: ExistingModelStorageCardProps) {
  const { t } = useTranslation();
  return (
    <div className={styles.card}>
      <div className={styles.row}>
        <div className={styles.col}>
          <div className={styles.colTitle}>{t('data-center:maas.section.model')}</div>
          <div className={styles.colBody}>{modelLines}</div>
        </div>
        <div className={styles.col}>
          <div className={styles.colTitle}>{t('data-center:shared.volume')}</div>
          <div className={styles.colBody}>{storageLines}</div>
        </div>
        {!readOnly ? (
          <div className={styles.actions}>
            <Space>
              {onEdit ? (
                <Button type="text" size="small" iconOnly icon={<IconEdit />} aria-label={t('common:edit')} onClick={onEdit} />
              ) : null}
              {onDelete ? (
                <Button
                  type="text"
                  size="small"
                  status="danger"
                  iconOnly
                  icon={<IconDelete />}
                  aria-label={t('common:delete')}
                  onClick={onDelete}
                />
              ) : null}
            </Space>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export function formatExistingModelColumn(entry: MaasModelSourceEntry | undefined, sourceSummary: string, sizeLabel?: string) {
  if (!entry) return '-';
  const parts = [
    entry.name || sourceSummary,
    sourceSummary !== entry.name ? sourceSummary : null,
    sizeLabel ? `${sizeLabel}` : null,
  ].filter(Boolean);
  return parts.join(' · ') || '-';
}
